import { useThrottleFn } from "@vueuse/shared";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";

export const useReactiveRendering = (
    elementRef,
    minimumRequiredSpace,
    scrollContainerId = "scroll-container"
) => {
    const spaceBelow = ref(null);
    const elementRefData = ref(null);

    const updateScroll = useThrottleFn(
        () => {
            const element = elementRef.value?.$el;

            if (!element) {
                return false;
            }

            spaceBelow.value =
                window.innerHeight - element.getBoundingClientRect()?.bottom;
        },
        100,
        true
    );

    const shouldRenderOnTop = computed(() => {
        if (spaceBelow.value === null) {
            const element = elementRef.value?.$el;

            if (!element) {
                return false;
            }

            spaceBelow.value =
                window.innerHeight - element.getBoundingClientRect()?.bottom;
        }

        return spaceBelow.value < minimumRequiredSpace.value;
    });

    onMounted(() => {
        updateElementRefData();

        // listen to scroll on provided scrollcontainer
        const scrollContainer = document.getElementById(scrollContainerId);

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", () => {
                updateScroll(scrollContainer);
            });
        }

        document.addEventListener("scroll", updateElementRefData, true);
    });

    onBeforeUnmount(() => {
        const scrollContainer = document.getElementById(scrollContainerId);

        if (scrollContainer) {
            scrollContainer.removeEventListener("scroll", () => {
                updateScroll(scrollContainer);
            });
        }

        document.removeEventListener("scroll", updateElementRefData, true);
    });

    const updateElementRefData = useThrottleFn(
        () => {
            elementRefData.value =
                elementRef.value?.$el?.getBoundingClientRect();
        },
        10,
        true,
        true
    );

    const placementStyles = computed(() => {
        if (!elementRefData.value) {
            return;
        }

        return {
            left: elementRefData.value?.left + "px",
            top:
                elementRefData.value?.top + elementRefData.value?.height + "px",
            width: elementRefData.value?.width + "px",
        };
    });

    return {
        shouldRenderOnTop,
        updateScroll,
        placementStyles,
    };
};
